export const IMAGE_CAPTURE_SETTINGS = {
  MAX_CAPTURE_DIMENSION: 2560,
  JPEG_QUALITY: 0.95,
  CAMERA_IDEAL_WIDTH: 2560,
  CAMERA_IDEAL_HEIGHT: 1920,
} as const
